var exports = {
  "p_": "list__5BUU2B",
  "xv": "CondensedForYouContainer__XgncPM",
  "sP": "CondensedForYouList__Ek5kAf",
};

module.exports = exports;
